export type ShopCategory =
  | "bake"
  | "cookie cutter"
  | "decorate"
  | "pack"
  | "storage";

export interface ShopItem {
  id: number;
  imageUrl: string;
  link: string;
  category: ShopCategory;
  onSale: boolean;
}

export const shopItems: ShopItem[] = [
  {
    id: 1,
    imageUrl: "https://m.media-amazon.com/images/I/61qnjK9Yr9L._AC_SL1500_.jpg",
    link: "https://amzn.to/4jryvNm",
    category: "bake",
    onSale: false,
  },
  {
    id: 2,
    imageUrl: "https://m.media-amazon.com/images/I/71TLjOnFL+L._AC_SL1500_.jpg",
    link: "https://amzn.to/3NqqaNC",
    category: "pack",
    onSale: false,
  },
  {
    id: 3,
    imageUrl: "https://m.media-amazon.com/images/I/61agM96JWRL._AC_SL1200_.jpg",
    link: "https://amzn.to/4bkzv3s",
    category: "pack",
    onSale: true,
  },
  {
    id: 4,
    imageUrl: "https://m.media-amazon.com/images/I/51tV2wP3rOL._SL1000_.jpg",
    link: "https://amzn.to/4sD60R1",
    category: "pack",
    onSale: false,
  },
  {
    id: 5,
    imageUrl: "https://m.media-amazon.com/images/I/61WJXahTzEL._AC_SL1400_.jpg",
    link: "https://amzn.to/44TnDSh",
    category: "pack",
    onSale: false,
  },
  {
    id: 6,
    imageUrl: "https://m.media-amazon.com/images/I/811+wMO2+1L._SL1500_.jpg",
    link: "https://amzn.to/3YDXKCx",
    category: "decorate",
    onSale: false,
  },
  {
    id: 7,
    imageUrl: "https://m.media-amazon.com/images/I/71BgTCp3XzL._AC_SL1500_.jpg",
    link: "https://amzn.to/4sgRcat",
    category: "decorate",
    onSale: false,
  },
  {
    id: 8,
    imageUrl: "https://m.media-amazon.com/images/I/714R-OW6N8L._AC_SL1500_.jpg",
    link: "https://amzn.to/4qE3Bnf",
    category: "decorate",
    onSale: false,
  },
  {
    id: 9,
    imageUrl: "https://m.media-amazon.com/images/I/81X7Bm8aG4L._AC_SL1500_.jpg",
    link: "https://amzn.to/3LrBecO",
    category: "decorate",
    onSale: false,
  },
  {
    id: 10,
    imageUrl: "https://m.media-amazon.com/images/I/41DI0+ktm8S._AC_SL1000_.jpg",
    link: "https://amzn.to/3YDY4kJ",
    category: "decorate",
    onSale: false,
  },
  {
    id: 11,
    imageUrl: "https://m.media-amazon.com/images/I/61Ycxul6qML._AC_SL1500_.jpg",
    link: "https://amzn.to/49ys2wp",
    category: "decorate",
    onSale: false,
  },
  {
    id: 12,
    imageUrl: "https://m.media-amazon.com/images/I/71aPrQeYKrL._AC_SL1500_.jpg",
    link: "https://amzn.to/3N09DjC",
    category: "pack",
    onSale: true,
  },
  {
    id: 13,
    imageUrl: "https://m.media-amazon.com/images/I/81Gik0nihuL._AC_SL1500_.jpg",
    link: "https://amzn.to/49gzVVV",
    category: "decorate",
    onSale: true,
  },
  {
    id: 14,
    imageUrl: "https://m.media-amazon.com/images/I/91gaUsxiqSL._AC_SL1500_.jpg",
    link: "https://amzn.to/4pWdwVb",
    category: "decorate",
    onSale: true,
  },
  {
    id: 15,
    imageUrl: "https://m.media-amazon.com/images/I/61E35tF2+dL._AC_SL1000_.jpg",
    link: "https://amzn.to/4pZYeyy",
    category: "decorate",
    onSale: false,
  },
  {
    id: 16,
    imageUrl: "https://m.media-amazon.com/images/I/71u9Hy7ZzBL._AC_SL1251_.jpg",
    link: "https://amzn.to/4pkgEZR",
    category: "bake",
    onSale: true,
  },
  {
    id: 17,
    imageUrl: "https://m.media-amazon.com/images/I/61-Cjv2t7VL._AC_SL1500_.jpg",
    link: "https://amzn.to/49znbet",
    category: "pack",
    onSale: false,
  },
  {
    id: 18,
    imageUrl: "https://m.media-amazon.com/images/I/71nxtCUvSuL._SL1500_.jpg",
    link: "https://amzn.to/49Az0kz",
    category: "decorate",
    onSale: false,
  },
  {
    id: 19,
    imageUrl: "https://m.media-amazon.com/images/I/61prDbDtD3L._AC_SL1500_.jpg",
    link: "https://amzn.to/492vKhV",
    category: "pack",
    onSale: true,
  },
  {
    id: 20,
    imageUrl: "https://m.media-amazon.com/images/I/711uYl6fPEL._SL1500_.jpg",
    link: "https://amzn.to/3MXIdLa",
    category: "decorate",
    onSale: false,
  },
  {
    id: 21,
    imageUrl: "https://m.media-amazon.com/images/I/71TdlKcTt5L._AC_SL1500_.jpg",
    link: "https://amzn.to/4q2Y5L5",
    category: "decorate",
    onSale: false,
  },
  {
    id: 22,
    imageUrl: "https://m.media-amazon.com/images/I/61VzXYwWGqL._SL1500_.jpg",
    link: "https://amzn.to/4qbTK8f",
    category: "decorate",
    onSale: false,
  },
  {
    id: 23,
    imageUrl: "https://m.media-amazon.com/images/I/918wiXgVXWS._AC_SL1500_.jpg",
    link: "https://amzn.to/3NqxvNa",
    category: "decorate",
    onSale: false,
  },
  {
    id: 24,
    imageUrl: "https://m.media-amazon.com/images/I/51Es34NenAL._AC_SL1500_.jpg",
    link: "https://amzn.to/4skwAhp",
    category: "decorate",
    onSale: false,
  },
  {
    id: 25,
    imageUrl: "https://m.media-amazon.com/images/I/51oaoWdLt1L._AC_SL1500_.jpg",
    link: "https://amzn.to/4qCj8ny",
    category: "decorate",
    onSale: false,
  },
  {
    id: 26,
    imageUrl: "https://m.media-amazon.com/images/I/61QjdSBFN0L._AC_SL1500_.jpg",
    link: "https://amzn.to/4bbPgJZ",
    category: "decorate",
    onSale: false,
  },
  {
    id: 27,
    imageUrl: "https://m.media-amazon.com/images/I/81MXKhWzR6L._AC_SL1500_.jpg",
    link: "https://amzn.to/3La7G3u",
    category: "cookie cutter",
    onSale: false,
  },
  {
    id: 28,
    imageUrl: "https://m.media-amazon.com/images/I/61E6r3VX5pL._AC_SL1500_.jpg",
    link: "https://amzn.to/4pfwhSh",
    category: "bake",
    onSale: false,
  },
  {
    id: 29,
    imageUrl: "https://m.media-amazon.com/images/I/81uRmbzg5iL._AC_SL1500_.jpg",
    link: "https://amzn.to/44Txc3D",
    category: "bake",
    onSale: false,
  },
  {
    id: 30,
    imageUrl: "https://m.media-amazon.com/images/I/81uo6QfSMeL._AC_SL1500_.jpg",
    link: "https://amzn.to/4pfxzg5",
    category: "bake",
    onSale: true,
  },
  {
    id: 31,
    imageUrl: "https://m.media-amazon.com/images/I/71pkbtgn5AL._AC_SL1500_.jpg",
    link: "https://amzn.to/4xjf2oB",
    category: "decorate",
    onSale: false,
  },
  {
    id: 32,
    imageUrl: "https://m.media-amazon.com/images/I/71Oc1smz7zL._AC_SL1500_.jpg",
    link: "https://amzn.to/3Q5k9Ie",
    category: "storage",
    onSale: false,
  },
  {
    id: 33,
    imageUrl: "https://m.media-amazon.com/images/I/61Se8DM-KSL._AC_SL1500_.jpg",
    link: "https://amzn.to/4ovV3iv",
    category: "cookie cutter",
    onSale: true,
  },
  {
    id: 34,
    imageUrl: "https://m.media-amazon.com/images/I/71RUJ0lQDHL._AC_SL1500_.jpg",
    link: "https://amzn.to/4fQMj4d",
    category: "storage",
    onSale: false,
  },
  {
    id: 35,
    imageUrl: "https://m.media-amazon.com/images/I/71IE+ZloZaL._AC_SL1500_.jpg",
    link: "https://amzn.to/4uUXBZ7",
    category: "decorate",
    onSale: false,
  },
  {
    id: 36,
    imageUrl: "https://m.media-amazon.com/images/I/613nLhfNBaL._AC_SL1500_.jpg",
    link: "https://amzn.to/4vQ0F9z",
    category: "cookie cutter",
    onSale: true,
  },
  {
    id: 37,
    imageUrl: "https://m.media-amazon.com/images/I/61a5OLd878L._AC_SL1500_.jpg",
    link: "https://amzn.to/4vOSpH0",
    category: "storage",
    onSale: false,
  },
  {
    id: 38,
    imageUrl: "https://m.media-amazon.com/images/I/71y639KhLyL._AC_SL1024_.jpg",
    link: "https://amzn.to/43zT6YA",
    category: "pack",
    onSale: false,
  },
  {
    id: 39,
    imageUrl: "https://m.media-amazon.com/images/I/710XhWUUudL._AC_SL1500_.jpg",
    link: "https://amzn.to/4xqCvUI",
    category: "pack",
    onSale: false,
  },
  {
    id: 40,
    imageUrl: "https://m.media-amazon.com/images/I/519TirEuDVL._SL1000_.jpg",
    link: "https://amzn.to/4vd38ev",
    category: "decorate",
    onSale: false,
  },
  {
    id: 41,
    imageUrl: "https://m.media-amazon.com/images/I/4163dJXna3L._AC_.jpg",
    link: "https://amzn.to/4ejCzyf",
    category: "decorate",
    onSale: true,
  },
  {
    id: 42,
    imageUrl: "https://m.media-amazon.com/images/I/51Vgn9epfUL._AC_SL1000_.jpg",
    link: "https://amzn.to/4xI7Rqc",
    category: "decorate",
    onSale: false,
  },
  {
    id: 43,
    imageUrl: "https://m.media-amazon.com/images/I/51u4iXVVBOL._AC_SL1500_.jpg",
    link: "https://amzn.to/4ewkOKC",
    category: "bake",
    onSale: true,
  },
  {
    id: 44,
    imageUrl: "https://m.media-amazon.com/images/I/712VzmiyiOL._AC_SL1500_.jpg",
    link: "https://amzn.to/4a4r8YI",
    category: "decorate",
    onSale: false,
  },
];
